import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_PDPA_REQUEST = 'pdpa/FETCH_PDPA_REQUEST'
const FETCH_PDPA_SUCCESS = 'pdpa/FETCH_PDPA_SUCCESS'
const FETCH_PDPA_FAILURE = 'pdpa/FETCH_PDPA_FAILURE'

const CREATE_PDPA_REQUEST = 'pdpa/CREATE_PDPA_REQUEST'
const CREATE_PDPA_SUCCESS = 'pdpa/CREATE_PDPA_SUCCESS'
const CREATE_PDPA_FAILURE = 'pdpa/CREATE_PDPA_FAILURE'

const UPDATE_PDPA_REQUEST = 'pdpa/UPDATE_PDPA_REQUEST'
const UPDATE_PDPA_SUCCESS = 'pdpa/UPDATE_PDPA_SUCCESS'
const UPDATE_PDPA_FAILURE = 'pdpa/UPDATE_PDPA_FAILURE'

const RESET_PDPA_REQUEST = 'pdpa/RESET_PDPA_REQUEST'
const RESET_PDPA_SUCCESS = 'pdpa/RESET_PDPA_SUCCESS'
const RESET_PDPA_FAILURE = 'pdpa/RESET_PDPA_FAILURE'

const DELETE_PDPA_REQUEST = 'pdpa/DELETE_PDPA_REQUEST'
const DELETE_PDPA_SUCCESS = 'pdpa/DELETE_PDPA_SUCCESS'
const DELETE_PDPA_FAILURE = 'pdpa/DELETE_PDPA_FAILURE'

// Initialize State
const initialState = {
  isLoading: false,
  error: {},
  pdpa: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PDPA_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_PDPA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pdpa: action.payload
      }
    case FETCH_PDPA_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_PDPA_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_PDPA_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_PDPA_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_PDPA_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_PDPA_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_PDPA_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case RESET_PDPA_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case RESET_PDPA_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case RESET_PDPA_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_PDPA_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_PDPA_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_PDPA_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

// Action Creators
export const fetchPDPA = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_PDPA_REQUEST
      })
      const response = await API.get(EndPoints.PDPA + `/all`)
      dispatch({
        type: FETCH_PDPA_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_PDPA_FAILURE
      })
    }
  }
}
export const createPDPA = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_PDPA_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.PDPA + `/createPDPA`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_PDPA_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_PDPA_FAILURE
      })
    }
  }
}
export const updatePDPA = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_PDPA_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.PDPA + `/updatePDPA`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_PDPA_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_PDPA_FAILURE
      })
    }
  }
}
export const resetPDPA = (appName) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: RESET_PDPA_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.PDPA + `/resetPDPA` + `/${appName}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: RESET_PDPA_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: RESET_PDPA_FAILURE
      })
    }
  }
}
export const deletePDPA = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_PDPA_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.PDPA + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_PDPA_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_PDPA_FAILURE
      })
    }
  }
}
